global.Calendar = (function ($) {
	function toggleHiddenEvents(button) {
		$('.js-event--passed').slideToggle();
		$(button).toggleClass('open');
	}

	function showEventDescription(button) {
		$(button).closest('.js-event').find('.js-event-description').show();
		$(button).closest('.js-event').find('.js-event-description').toggleClass('open');
		$(button).closest('.js-event').find('.js-show-less').show();
		$(button).hide();

		var url = $(button).find('a').attr('href');
		window.history.pushState('', '', url);

		$('html, body').animate({ scrollTop: $('#' + $(button).data('eventid')).offset().top }, 'slow');
	}

	function hideEventDescription(button) {
		$(button).closest('.js-event').find('.js-event-description').hide();
		$(button).closest('.js-event').find('.js-event-description').removeClass('open');
		$(button).closest('.js-event').find('.js-show-more').show();
		$(button).hide();
	}

	function init(eventGuid) {
		if (eventGuid !== undefined && eventGuid !== '') {
			$('html, body').animate({ scrollTop: $('#event-' + eventGuid).offset().top }, 'slow');
		}

		$('.js-show-hidden').click(function () {
			toggleHiddenEvents(this);
		});

		$('.js-filter-month-dropdown').on('change', function () {
			$(this).parents('form').submit();
		});

		$('.js-show-more').on('click', function (e) {
			e.preventDefault();
			showEventDescription(this);
		});

		$('.js-show-less').on('click', function (e) {
			e.preventDefault();
			hideEventDescription(this);
		});
	}

	return {
		init: init
	};
})(jQuery);
